import { useMemo } from 'react';

import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { GetUser, getUser } from '../api';
import { usersQueryKeys } from '../data';

type CustomQueryOptions<
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> = Omit<
  UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
  'queryKey' | 'queryFn'
> &
  Partial<Pick<UseQueryOptions, 'queryKey'>> & {
    // NOTE: Experimental
    shouldPrependOrigKey?: boolean;
  };

export const useUserQuery = (
  queryOptions?: CustomQueryOptions<GetUser['return']>,
) => {
  const accessToken = localStorage.getItem('access_token');
  const hasAccessToken = Boolean(accessToken);

  const queryKey = useMemo(
    () =>
      queryOptions?.queryKey
        ? queryOptions?.shouldPrependOrigKey
          ? [...usersQueryKeys.getUserInfo, ...queryOptions.queryKey]
          : queryOptions.queryKey
        : usersQueryKeys.getUserInfo,
    [queryOptions],
  );

  const query = useQuery({
    staleTime: Infinity,
    ...queryOptions,
    queryKey: queryKey,
    queryFn: getUser,
    enabled: hasAccessToken && queryOptions?.enabled !== false,
  });

  return query;
};
